import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsShowNotification, selectSavedOfferId } from '../../selectors';
import { TooltipContainer } from '../TooltipContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function FavoriteButtonWrapperContainer(_ref) {
  var offerId = _ref.offerId,
    placement = _ref.placement,
    children = _ref.children,
    onClickFolderName = _ref.onClickFolderName,
    isAuthenticated = _ref.isAuthenticated,
    _ref$onWaitForLogin = _ref.onWaitForLogin,
    onWaitForLogin = _ref$onWaitForLogin === void 0 ? function () {} : _ref$onWaitForLogin;
  var buttonRef = React.useRef(null);
  var isTooltipVisible = useSelector(selectIsShowNotification);
  var savedOfferIds = useSelector(selectSavedOfferId);
  var isOfferSelected = savedOfferIds.length === 1 && savedOfferIds[0] === offerId;
  var handleClick = function handleClick(e) {
    e.stopPropagation();
  };
  return /*#__PURE__*/_jsxs("div", {
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx("div", {
      ref: buttonRef,
      children: children
    }), /*#__PURE__*/_jsx(TooltipContainer, {
      isAuthenticated: isAuthenticated,
      onWaitForLogin: onWaitForLogin,
      buttonRef: buttonRef,
      placement: placement,
      onClickFolderName: onClickFolderName,
      isOpen: isTooltipVisible && isOfferSelected
    })]
  });
}